export default __webpack_public_path__ + "cars.224ba2a09dffe03976b7909553d823c1.png";